/**
 * @see https://umijs.org/zh-CN/plugins/plugin-access
 * */
export default function access(
  initialState:
    | {
        currentUser?: API.CurrentUser;
        roles?: [string];
        permissions?: [];
        schedulingUser: object;
        isBusinessLeader?: boolean;
        isMainProductManager?: boolean;
        isSystemInterfaceManager?: boolean;
      }
    | undefined,
) {
  const { currentUser, roles, schedulingUser } = initialState ?? {};
  const isCto = roles?.includes('CTO');
  const hasRole = (role: string) => roles?.includes(role);
  const hasAnyRole = (targetRoles: string[]) => roles?.some((val) => targetRoles.includes(val));
  const withCto = (accessible: boolean | undefined) => Boolean(isCto || accessible);

  return {
    //值班人
    canScheduling:
      currentUser && schedulingUser && currentUser.userName === schedulingUser?.userCode,
    normalRolesFilter: (role: string[]) => roles?.some((val) => role.includes(val)), // initialState 中包含了的路由才有权限访问
    canAdmin: hasRole('admin'),
    canSls: withCto(hasRole('sls')),
    canWebLog: withCto(hasRole('webLog')),
    canLogCenter: withCto(hasRole('logCenter')),
    canDevelopLog: withCto(hasRole('developLog')),
    canCS: withCto(hasRole('clickVisual')),
    canTool: withCto(hasAnyRole(['sls', 'clickVisual', 'polarDB'])),
    canCto: isCto,
    canEfficiencyTeamComparison: isCto,
    canDevops: withCto(hasRole('devops')),
    canLeader: withCto(hasRole('team_leader')),
    canApproval: withCto(hasAnyRole(['approval_admin'])),
    canBusinessLeader: withCto(Boolean(initialState?.isBusinessLeader)),
    canBusinessDashboard: withCto(
      Boolean(
        initialState?.isBusinessLeader ||
          initialState?.isMainProductManager ||
          initialState?.isSystemInterfaceManager,
      ),
    ),
    canGrayReleaseConfig: withCto(hasRole('gray_release_config')),
    canRelease: hasAnyRole(['qa', 'frontend', 'backend', 'release_duty']),
    canK8sConfig: withCto(hasRole('devops')), // k8s集群配置权限
    canViewBusiness: withCto(
      hasAnyRole(['PO', 'PMO']) ||
        // initialState?.isBusinessLeader,
        Boolean(initialState?.isBusinessParticipant),
    ),
    canIssueDashboard: withCto(hasAnyRole(['PMO', 'PO', 'Product Manager'])),
    canAiCoding: withCto(hasAnyRole(['frontend', 'backend'])),
    canFeedbackAdmin: withCto(hasRole('FBM')),
    canLcAdmin: withCto(hasRole('card_like_manager')),
    // canDelivery: roles?.includes('qa'),
  };
}
